import { Trans } from '@lingui/react/macro';
import { Text } from '@/clients/shared-components/Typography';

export function Disclaimer() {
  return (
    <Text s warm50>
      <Trans>
        ProfAI uses AI to generate learning exercises. Content and exercises may contain occasional
        inaccuracies.
      </Trans>
    </Text>
  );
}
